import { POLICY_PATH } from "./constants";
export const isPolicyPage = (pathname) => POLICY_PATH.indexOf(pathname) > -1;